import {KpiType} from '@hconnect/common/types'

export const RELIABILITY_ENGINEER_KPI_TYPES = [
  KpiType.ClinkerProduction,
  KpiType.CementProduction,
  KpiType.KilnHeatConsumptionPerEquipment,
  KpiType.KilnOperationCoefficientPerEquipment,
  KpiType.AlternativeFuelRatePerEquipment,
  KpiType.KilnMTBFPerEquipment,
  KpiType.KilnReliabilityCoefficientPerEquipment,
  KpiType.FinishMillSpecificPowerConsumptionPerEquipment,
  KpiType.FinishMillOutputPerEquipment,
  KpiType.FinishMillOperatingCoefficientPerEquipment,
  KpiType.KilnProcessCoefficientPerEquipment
]

export const PROCESS_ENGINEER_KPI_TYPES = [
  KpiType.ClinkerProduction,
  KpiType.CementProduction,
  KpiType.KilnHeatConsumptionPerEquipment,
  KpiType.KilnSpecificPowerConsumptionMainDrivePerEquipment,
  KpiType.ClinkerProductionRatePerEquipment,
  KpiType.KilnOperationCoefficientPerEquipment,
  KpiType.KilnProcessCoefficientPerEquipment,
  KpiType.AlternativeFuelRatePerEquipment,
  KpiType.RawMillSpecificPowerConsumptionMainDrivePerEquipment,
  KpiType.RawMillOutputPerEquipment,
  KpiType.FinishMillSpecificPowerConsumptionPerEquipment,
  KpiType.FinishMillOutputPerEquipment,
  KpiType.FinishMillOperatingCoefficientPerEquipment
]
